define('webshopCategoriesDetailBodyCategoryBodyIndexView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'checkboxView',
  'template!webshopCategoriesDetailBodyCategoryBodyIndexView'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  CheckboxView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'index-view',

    regions: {
      checkboxRegion: '.checkbox-region'
    },

    serializeData: function () {
      var data = {};
      data.lang = this.model.get('lang');
      return data;
    },

    onShow: function () {
      this.checkboxView = new CheckboxView({
        title: this.model.get('lang'),
        text: this.model.get('lang'),
        value: this.model.get('value'),
        onChange: _.bind(function (value) {
          var defer = $.Deferred();
          this.options.category.setIndex(this.model.get('lang'), value).done(_.bind(function () {
            this.options.category.fetch().done(_.bind(function () {
              this.checkboxView.setValue(this.options.category.getIndex(this.model.get('lang')));
              defer.resolve();
            }, this));
          }, this)).fail(_.bind(function () {
            this.options.category.fetch().done(_.bind(function () {
              defer.reject();
            }, this));
          }, this));
          return defer.promise();
        }, this)
      });
      this.checkboxRegion.show(this.checkboxView);
      this.checkboxView.on('click', _.bind(this.onClick, this));

      //-----------------------------
      this.listenTo(this.options.category, 'change', _.bind(function (model) {
        if (model.hasChanged('noIndex')) {
          if (this.options.category.getIndex(this.model.get('lang')) !== this.checkboxView.getValue())
            this.checkboxView.setValue(this.options.category.getIndex(this.model.get('lang')));
        }
      }, this));
    },

    onClick: function (view) {
      this.model.set('value', view.getValue());
    }
  });
});
